import CSVPreviewSection from '../CSVPreviewSection'

export default function StaffPerformanceCSVPreviewLeavesSection() {}

StaffPerformanceCSVPreviewLeavesSection.prototype = new CSVPreviewSection();

StaffPerformanceCSVPreviewLeavesSection.prototype.init = function ( columnsStrategy, numOfGroupingCols )
{
    CSVPreviewSection.prototype.init.call( this );
    this.columnsStrategy = columnsStrategy;
    this.numOfGroupingCols = numOfGroupingCols;
    return this;
};

StaffPerformanceCSVPreviewLeavesSection.prototype.addRows = function ( tBody )
{
    this.addEmptyRow( tBody );

    for( let i = 0; i < 2; i++ )
    {
        const row = this.createRow()
        ReportPreviewUtils.addCell( row, this.message("leave_type.leave_type") );
        ReportPreviewUtils.addEmptyCells( row, this.numOfGroupingCols - 1 );
        this.columnsStrategy.addDataCells( row );
        this.addRow( tBody, row );
    }

    this.addEmptyRow( tBody );

    const totalsRow = this.createRow()
    if( this.numOfGroupingCols === 1 )
        this.addCell( totalsRow, this.message("report.staffoutput.total_working_leave_time") );
    else
        this.addCellWithFloatingContent( totalsRow, this.message("report.staffoutput.total_working_leave_time") );
    ReportPreviewUtils.addEmptyCells( totalsRow, this.numOfGroupingCols - 1 );
    this.columnsStrategy.addDataCells( totalsRow );
    this.addRow( tBody, totalsRow );

};

StaffPerformanceCSVPreviewLeavesSection.prototype.addEmptyRow = function ( tBody )
{
    const emptyRow = this.createRow()
    ReportPreviewUtils.addEmptyCells( emptyRow, this.numOfGroupingCols );
    this.columnsStrategy.addEmptyCells( emptyRow );
    this.addRow( tBody, emptyRow );
};



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewLeavesSection.js